import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type EditUserStoresResponseType = {};

type EditUserDataParams = {
  user_id: number;
  store_ids: (number | undefined)[];
};

export const useEditUserStores = (
  options?: MutationOptions<
    EditUserStoresResponseType,
    EditUserDataParams,
    AxiosError<ApiError>
  >
) =>
  useMutation({
    mutationFn: async ({ user_id, store_ids }) => {
      const { data } = await api.patch<ApiResponse<EditUserStoresResponseType>>(
        `/user/stores`,
        { user_id, store_ids }
      );

      return data.data;
    },

    ...options,
  });
